import CryptoJS from 'crypto-js'
import encrypt from './encryptConfig'

const replacements = {
  '-': '+',
  '_': '/',
  '~': '='
}

export const decrypt = (str) => {
  const newStr = str.replace(/(-)|(_)|(~)/g, function (match) { return replacements[match] })
  const key = CryptoJS.enc.Utf8.parse(encrypt.key)
  const iv = CryptoJS.enc.Utf8.parse(encrypt.iv)
  const decrypted = CryptoJS.AES.decrypt(newStr, key, {iv: iv, padding: CryptoJS.pad.Pkcs7})
  return decrypted.toString(CryptoJS.enc.Utf8)
}
